enum PrecaucoesEnum {
  Sim = 'Sim',
  Nao = 'Nao',
  PrecaucaoRespiratoriaPorGoticulas = 'PrecaucaoRespiratoriaPorGoticulas',
  PrecaucaoRespiratoriaPorAerosol = 'PrecaucaoRespiratoriaPorAerosol',
  PrecaucaoPorContatoERespiratoriaPorAerosol = 'PrecaucaoPorContatoERespiratoriaPorAerosol',
  PrecaucaoEspecial = 'PrecaucaoEspecial',
  Outro = 'Outro',
}

export default PrecaucoesEnum
